import { put } from "redux-saga/effects";

import { GetUserMetadataResponse, UpdateUserMetadataResponse } from "redmond";
import { actions } from "../actions";
import { updateUserMetadata } from "../../../api/v0/user/updateUserMetadata";
import fetchUserMetadata from "../../../api/v0/user/fetchUserMetadata";

export function* updateHasSeenPackageSmokeTestSaga(
  action: actions.IUpdateHasSeenPackageSmokeTest
) {
  try {
    const res: UpdateUserMetadataResponse = yield updateUserMetadata({
      userMetadata: {
        hasSeenPackageSmokeTest: action.hasSeen,
      },
    });

    if (res.Response !== "Success") {
      throw new Error("Failed to update metadata");
    }

    const newSavedPreferences: GetUserMetadataResponse =
      yield fetchUserMetadata({
        keys: ["hasSeenPackageSmokeTest"],
      });

    yield put(
      actions.setHasSeenPackageSmokeTest(
        newSavedPreferences.userMetadata.hasSeenPackageSmokeTest
      )
    );
  } catch (e) {
    console.error(e);
  }
}
